import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutLMEUserTemplates extends Layout {
    sourceUserSettings: DataSource;
    textboxConfTemplate: Textbox;
    textboxLtlQuoteTemplate: Textbox;
    textboxQuoteTemplate: Textbox;
}
